/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
  const updateCount = (count) => {
    if (!this.itemsCount) return;

    this.itemsCount.textContent = count.toString();

    const badge = this.itemsCount.closest(".cart-count-bubble");
    if (badge) {
      if (Number(count) === 0) {
        badge.style.setProperty("display", "none", "important");
      } else {
        badge.style.removeProperty("display");
      }
    }
  };

  if (this.itemsCount) {
    updateCount(Number(this.itemsCount.textContent.trim()));
  }

  this.unsubscribe = Cart.subscribe((state) => {
    updateCount(state.cart.item_count);
  });
}

    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
